module.exports = __webpack_public_path__ + "static/media/8C.55a0952d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/8C.svg
// module id = 77
// module chunks = 0